import React, { createContext, useContext, useState } from 'react';

interface FTAImpactContextType {
    dataTable: Array<object>;
    setDataTable: (data: Array<object>) => void;
    year: String;
    setYear: (year: String) => void;
    reporter: String;
    setReporter: (reporter: String) => void;
    partner: String;
    setPartner: (partner: String) => void;
}

const FTAImpactContext = createContext<FTAImpactContextType | undefined>(undefined);

const FTAImpactProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [dataTable, setDataTable] = useState<Array<object>>([]);
    const [year, setYear] = useState<String>('');
    const [reporter, setReporter] = useState<String>('');
    const [partner, setPartner] = useState<String>('');

    return (
        <FTAImpactContext.Provider value={{ 
            dataTable, setDataTable,
            year, setYear,
            reporter, setReporter,
            partner, setPartner 
        }}>
            {children}
        </FTAImpactContext.Provider>
    );
};

const useFTAImpactContext = () => {
    const context = useContext(FTAImpactContext);
    if (context === undefined) {
        throw new Error('useFTAImpactContext must be used within a FTAImpactProvider');
    }
    return context;
};

export {
    FTAImpactContext, 
    FTAImpactProvider,  
    useFTAImpactContext
}